import React from "react";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import SliderInput from "./QuestionInputSlider";
import RadioInput from "./QuestionInputRadio";
import { IQuestion, InputType } from "../../surveyTypes";
import { SurveyFormContext } from "../Survey";
import { SurveySectionContext } from "../SurveySection";

const Question: React.FC<IQuestion> = (props: IQuestion) => {
  const { questionText, id } = props;
  const { answers } = React.useContext(SurveyFormContext);
  const { minValue, maxValue, step, inputType } = React.useContext(
    SurveySectionContext
  );
  let checkedValue = null;
  if (id in answers) {
    checkedValue = answers[id].value;
  }

  return (
    <TableRow>
      <TableCell>{questionText}</TableCell>
      {inputType === InputType.RADIO && (
        <RadioInput
          checkedValue={checkedValue}
          questionId={id}
          min_value={minValue}
          max_value={maxValue}
          step={step}
        />
      )}
      {inputType === InputType.SLIDER && (
        <SliderInput
          checkedValue={checkedValue}
          questionId={id}
          min_value={minValue}
          max_value={maxValue}
          step={step}
        />
      )}
    </TableRow>
  );
};

export default Question;
